import type * as React from 'react';
import type { FC } from 'react';

import { CustomNextImage as Image } from '@crehana/next';

import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

const Guarantee: FC<
  React.PropsWithChildren<{
    className?: string;
  }>
> = ({ className }) => {
  const {
    state: { totalPrice },
    currency,
  } = useCheckoutCtx();

  return (
    <div className={className}>
      <div className="sm:flex items-center mt-16 sm:flex-shrink-0 mb-24">
        <div>
          <Image
            src={
              'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-510c8265-87c3-4598-8640-8168c09d753a-garantia.png?auto=format'
            }
            width={84}
            height={64}
            alt="Garantía"
          />
        </div>
        <p className="font-legals text-gray-dark sm:ml-16">
          Si tu experiencia con la compra no es lo que esperabas, te haremos un
          reembolso del 100% de tu pago. Por favor revisar nuestras{' '}
          <a
            className="font-legal text-gray-dark ml-4"
            target="_blank"
            href="/legal/terminos-y-condiciones/"
            style={{ textDecoration: 'underline' }}
          >
            Políticas de Reembolso
          </a>
        </p>
      </div>
      <p className="font-legals text-gray-dark mb-24">
        El cobro va a ser de {currency} {totalPrice}, los precios base que
        manejamos son en dólares. El monto que ves en tu moneda local es un
        aproximado que puede variar de acuerdo a tu banco y el tipo de cambio
        del día.
      </p>
      <p className="font-legals text-gray-dark">
        (1) Acepto expresamente todos los Términos y Condiciones de Membresías
        Premium y Pay As You Go. Del mismo, modo acepto las Políticas y Avisos
        de Protección y Tratamiento de Datos Personales de Crehana: Generales,
        Colombia, México.
      </p>
    </div>
  );
};

export default Guarantee;
